import moment from 'moment'

export class ChartUtilities {
  /* eslint-disable max-params */
  /* eslint-disable complexity */
  static pruneXAxisTicks(tick, index, ticks, xMaxTicksLimit, ticksArray) {
    let formattedTick = moment(tick).format('MMM D')
    const stepSize = xMaxTicksLimit
      ? Math.ceil(ticks.length / xMaxTicksLimit)
      : 1
    const isDuplicate = ticksArray.includes(formattedTick)
    const isNeitherFirstNorLast = index !== 0 && index !== ticks.length - 1
    const shouldSkip = stepSize > 1 && index % stepSize !== 0
    if (stepSize > 1) {
      if (isNeitherFirstNorLast && (isDuplicate || shouldSkip)) {
        return null
      }
      ticksArray.push(formattedTick)
    }
    return formattedTick
  }
}
